export default __webpack_public_path__ + "static/media/scale.fa8e6efc.svg";